export default "/static/js/bin/images/8e573a4cf60f8b5d7b9fd64f379e7c53.png";